<div class="search-widget-container">
  <div class="search-input-container">
    <input
      type="text"
      class="form-control"
      placeholder="Encontrar chamado"
      [(ngModel)]="findTicketText"
      (keyup.enter)="findTicketByNumerOrID()" />
  </div>
  <app-notifications-dropdown></app-notifications-dropdown>
</div>
